// extracted by mini-css-extract-plugin
export default {"stockList":"index_stockList_Cdms9","red":"index_red_RCTZ4","current":"index_current_kWyV1"};